<template>
  <div>
    {{ presentAddress | parseBlankForDefaultValue('--', '', '', false) }}
    {{ member.birthdate | parseAge | parseBlankForDefaultValue('--', '', '歳', false) }}
    {{ getNameOrUndefined(member, 'gender.name') | parseBlankForDefaultValue('--', '', '', false) }}
    / {{ member.employed | convertEmployedLabel | parseBlankForDefaultValue('--', '', '', false) }}
    / {{ annualSalary | parseBlankForDefaultValue('--', '年収', '万円', false) }}
    / {{ member.changeOverJobsCount | convertchangeOverJobsCountLabel | parseBlankForDefaultValue('--', '転職', '', false) }}
  </div>
</template>

<script>
import _ from 'lodash'
import * as parse from '@/lib/parse'
import * as definition from '@/lib/labelValueMappings'
import resumeParseUtils from '@/lib/resumeParseUtils'

export default {
  filters: {
    parseAge (birthdateString) {
      return parse.age(birthdateString)
    },
    convertEmployedLabel (id) {
      return id ? definition.employed[id].name : ''
    },
    convertchangeOverJobsCountLabel (id) {
      return _.isNumber(id) ? definition.job[id].name : ''
    }
  },
  mixins: [resumeParseUtils],
  props: {
    member: {
      type: Object,
      required: true
    }
  },
  computed: {
    presentAddress () {
      const prefecture = this.getNameOrUndefined(this.member, 'presentAddressPrefecture.name')
      const city = this.getNameOrUndefined(this.member, 'presentAddressCity.name')
      return prefecture ? city ? `${prefecture} ${city}` : prefecture : ''
    },
    annualSalary () {
      const annualSalaryPath = this.member.careerResume ? 'careerResume.annualSalary' : 'careerResumes[0].annualSalary'
      return this.getNameOrUndefined(this.member, annualSalaryPath)
    }
  }
}
</script>
